import { createActionsHook, createHook, createStore } from 'react-sweet-state';
export type RovoApp = {
	source: string;
	friendlyName: string;
};
export type FiltererdOrgKnowledge = {
	// enalbed with filtered apps, in absence of filtered apps, it's enabled for all apps
	filteredApps: RovoApp[];
};
export type OrgKnowledge = 'disabled' | FiltererdOrgKnowledge;

export type ChatMode = {
	deepResearchEnabled: boolean;
	webSearchEnabled: boolean;
	orgKnowledge: OrgKnowledge;
};

const store = createStore({
	initialState: {
		deepResearchEnabled: false,
		webSearchEnabled: false,
		orgKnowledge: {
			filteredApps: [],
		},
	} as ChatMode,
	actions: {
		setDeepResearchEnabled:
			(isEnabled: boolean) =>
			({ setState }) => {
				setState({
					deepResearchEnabled: isEnabled,
				});
			},
		setWebSearchEnabled:
			(isEnabled: boolean) =>
			({ setState }) => {
				setState({
					webSearchEnabled: isEnabled,
				});
			},
		setOrgKnowledge:
			(orgKnowledge: OrgKnowledge) =>
			({ setState }) => {
				setState({
					orgKnowledge,
				});
			},
		getChatMode:
			() =>
			({ getState }) => {
				const state = getState();
				let appFilters: string[] | undefined;
				if (state.orgKnowledge === 'disabled') {
					// no org knowledge applied at all.
					appFilters = [];
				} else if (state.orgKnowledge.filteredApps.length === 0) {
					// all org knowledge applied and no apps filtered.
					appFilters = undefined;
				} else {
					// org knowledge applied and apps filtered.
					appFilters = state.orgKnowledge.filteredApps.map((app) => app.source);
				}
				return {
					...state,
					appFilters: appFilters,
				};
			},
	},
});

export const useChatModeStore = createHook(store);
export const useChatModeStoreActions = createActionsHook(store);
export const useChatModeState: () => ChatMode = () => useChatModeStore()[0];
